import type { IModalConfig } from "pro-features/components/Modals/src/UnlockModal/modalTypes";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import { allTrackers } from "app/services/track/track";

export type SalesUnlockModalConfigType = {
    InsightsGeneratorFeature: "InsightsGeneratorFeature";
    ContactsFeature: "ContactsFeature";
    LeadsFeature: "LeadsFeature";
};

export const createSalesUnlockModalConfig = (
    translate: (key: string) => string,
    assetsService: { assetUrl(path: string): string },
): {
    [K in keyof SalesUnlockModalConfigType]: IModalConfig<SalesUnlockModalConfigType[K]>;
} => {
    return {
        InsightsGeneratorFeature: {
            slides: {
                InsightsGeneratorFeature: {
                    img: assetsService.assetUrl("/images/sales-intelligence/insights-generator-illustration.svg"),
                    imgWidth: 350,
                    title: translate("hook_unlock.si_insights_generator.title"),
                    text: translate("hook_unlock.si_insights_generator.text"),
                    subtitle: translate("hook_unlock.si_insights_generator.subtitle"),
                },
            },
            ctaText: translate("hook_unlock.si_insights_generator.button"),
            label: "Insights Generator",
        },
        ContactsFeature: {
            slides: {
                ContactsFeature: {
                    img: assetsService.assetUrl("/images/sales-intelligence/insights-generator-illustration.svg"),
                    imgWidth: 350,
                    title: translate("Contacts"),
                    text: translate(
                        "Get access to the contact information of decision makers at the companies you’re interested in, including their business phone & email. You can filter by job title, seniority level, department or location.",
                    ),
                    subtitle: translate("Find the right decision makers for your sales outreach"),
                },
            },
            ctaText: translate("hook_unlock.si_insights_generator.button"),
            label: "Contacts",
            onCtaClickTrack: () => {
                const { integrationName = "" } = getIntegrationNameFromUrl();
                allTrackers.trackEvent(`${integrationName} integration`, "request access", `contacts results/admin`);
            },
        },
        LeadsFeature: {
            slides: {
                LeadsFeature: {
                    img: assetsService.assetUrl("/images/sales-intelligence/insights-generator-illustration.svg"),
                    imgWidth: 350,
                    title: translate("Leads"),
                    text: translate(
                        "Get access to the leads information of decision makers at the companies you’re interested in, including their business phone & email. You can filter by job title, seniority level, department or location.",
                    ),
                    subtitle: translate("hook_unlock.si_insights_generator.subtitle"),
                },
            },
            ctaText: translate("hook_unlock.si_insights_generator.button"),
            label: "Leads",
        },
    };
};
